import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { BlockProps } from '../props'
import { default as UrpsFactsBlock } from '../../../components/blocks/BlockUrpsFacts'
import SectionWrapper from '../../../components/SectionWrapper'

import { UrpsFactsProps } from './props'

const BlockUrpsFacts: FC<BlockProps<UrpsFactsProps>> = ({ data }) => {
  const { t } = useTranslation()
  return (
    <SectionWrapper spacing="big">
      <UrpsFactsBlock
        title={data.title ?? ''}
        items={[
          {
            icon: {
              icon: 'factViews',
              width: 160,
              height: 154,
            },
            value: t('urps_facts_views_value'),
            text: t('urps_facts_views_title'),
          },
          {
            icon: {
              icon: 'factAnswers',
              width: 160,
              height: 154,
            },
            value: t('urps_facts_answers_value'),
            text: t('urps_facts_answers_title'),
          },
          {
            icon: {
              icon: 'factTotal',
              width: 160,
              height: 154,
            },
            value: t('urps_facts_total_value'),
            text: t('urps_facts_total_title'),
          },
        ]}
      />
    </SectionWrapper>
  )
}
export default BlockUrpsFacts
